import React from 'react';
import styled from 'styled-components';
import ItineraryMap from './ItineraryMap';

const MapContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
`;

const TripMap = ({ pois, amenities, hasUnsavedChanges }) => {
  return (
    <MapContainer>
      <ItineraryMap 
        pois={pois} 
        amenities={amenities} 
        hasUnsavedChanges={hasUnsavedChanges} 
      />
    </MapContainer>
  );
};

export default TripMap;
